import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import { getTvCustomerList,setParentalCodeStep,resetState } from '../TvActivationCodeRecoveryBlock/TvActivationCodeRecoveryBlockSlice';
import TvCustomerList from './TvCustomerList';
import ResetCode from './ResetCode';
import {Step} from './ResetParentalCodeEnum';
import Helper from '../../../utilities/helper';
import {redirectToLogin} from '../ChangePricePlanBlock/changePricePlanSlice';
import VerifyTVInfo from './VerifyTVInfo';
//import ResetCodeCompleted from './ResetCodeCompleted';

const MainTvResetParentalCode = (props) => {
    useEffect(() => {
        return () => {
            props.resetState();
        };
    }, []);


    // useEffect(() => {
    //     setPinCode(props.pinParentalCode);
    // }, [props.pinParentalCode]);

    useEffect(() => {
        
        if (!props.authentication?.loginData?.isFullAuthenticated) {
            setParentalCodeStep(Step.LOGIN);
            return;
        }

        props.getTvCustomerList({ isParentalCode:true });

        const customersAmount = props.tvAccounts.customerList?.length;
        if (customersAmount == 0) {
            setParentalCodeStep(Step.ERROR);
        }
    }, [props.authentication?.loginData?.isFullAuthenticated]);

    let goToLogin = () => {
        let returnUrl = encodeURIComponent(window.location.pathname + window.location.hash.toLowerCase().split('#')[0]);
        let cancelUrl = Helper.getRedirectToLoginReturnAndCancelUrl()?.cancelUrl;
        let template = '';
        props.redirectToLogin({returnUrl: returnUrl, cancelUrl: cancelUrl, template: template});
    };

    let currentStep = () => {
        switch (props.step) {
            case Step.START:
                return (
                    <TvCustomerList
                        customerList={props.tvAccounts.customerList}
                        title={props.contentData?.title?.value}
                        context={props.context}
                        cellTvPage={props.contentData?.cellTvPage?.value}
                    />
                );
            case Step.RESET_CODE:
                return (
                    <ResetCode
                        customerList={props.tvAccounts.customerList}
                        title={props.contentData?.title?.value}
                        context={props.context}
                        userData={props.authentication?.loginData?.userDetails}
                    />
                );

            case Step.VERIFY_ACCOUNT:
                return (

                    <div className='tv-customer-list'>
                        <div className='title-info'>{props.contentData?.title?.value}</div>
                        <Image src={require('./images/logo.svg')} alt='logo-icon' />
                        <VerifyTVInfo
                            customerList={props.tvAccounts.customerList}
                            title={props.contentData?.title?.value}
                            context={props.context}
                            userData={props.authentication?.loginData?.userDetails}
                        />
                    </div>
                );

            case Step.LOGIN:
                return (
                    <div>
                        {goToLogin()}
                    </div>
                );

            // case Step.COMPLETED_PAGE:
            //     return (
            //         <ResetCodeCompleted
            //             context={props.context}
            //             userData={props.authentication?.loginData?.userDetails}
            //             account={account}
            //             numOfAccounts={props.tvAccounts?.customerList?.length}
            //         />
            //     );


        }

    }

    return (
        <div className='tv-parental-code'>
            {currentStep()}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        tvAccounts: state.TvActivationCodeRecovery,
        authentication: state.authentication,
        step: state.TvActivationCodeRecovery?.parentalCodeStep,
        currentParrentalCodeAccount: state.TvActivationCodeRecovery.currentParrentalCodeAccount,
        selectedCustomer: state.TvActivationCodeRecovery.selectedCustomer,
        getCustomersReady: state.TvActivationCodeRecovery?.getCustomersReady
    };
};

const mapDispatchToProps = {
    getTvCustomerList,
    setParentalCodeStep,
    redirectToLogin,
    resetState,
};
export default connect(mapStateToProps, mapDispatchToProps)(MainTvResetParentalCode);
